import * as React from "react";
import { forwardRef } from "react";
const SvgEmail = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 40 40", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M31.1 9.7H8.8a4.7 4.7 0 0 0-4.7 4.7v11.2a4.7 4.7 0 0 0 4.7 4.7h22.3a4.7 4.7 0 0 0 4.7-4.7V14.4a4.7 4.7 0 0 0-4.7-4.7Zm0 1.3c.8 0 1.5.2 2.1.7L23 21.9a4 4 0 0 1-5.7 0L6.9 11.6c.6-.4 1.2-.6 2-.6H31Zm3.5 14.6a3.4 3.4 0 0 1-3.5 3.5H8.8a3.4 3.4 0 0 1-3.4-3.5V14.4c0-.7.2-1.4.6-2l10.4 10.4a5.3 5.3 0 0 0 7.5 0L34 12.6c.3.6.5 1.2.5 1.8v11.2Z" }));
const ForwardRef = forwardRef(SvgEmail);
export { ForwardRef as ReactComponent };
